import React, { Component } from 'react';
import { Form, Input, Col, Row, Modal, Divider } from 'antd';
import Big from 'big.js';
import SelectApportionObj from './SelectApportionObj';
import './ModalApprtion.less';

const FormItem = Form.Item;
const type = ['非公摊', '单次公摊', '多次公摊'];

class ModalApportion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      count: '0',
      minus: 0,
      avg: 0,
    };
  }

  componentDidMount() {}

  handleChange = params => {
    this.details = params;
    if (params && params.length > 0) {
      this.setState({
        count: this.getCountSum(params),
        minus: this.getMinus(params),
        avg: this.getAvg(params),
      });
    } else {
      this.setState({
        count: '-',
        minus: '',
        avg: '-',
      });
    }
  };

  getCountSum = data => {
    const countSum = data.reduce((prev, curr) => {
      return prev + curr.count;
    }, 0);
    return countSum;
  };

  getAvg = params => {
    const { price } = this.props.form.getFieldsValue();
    return new Big(price || 0).div(new Big(this.getCountSum(params))).toFixed(2);
  };

  getMinus = params => {
    const { price } = this.props.form.getFieldsValue();
    const sum = params.reduce((prev, curr) => {
      return prev.plus(new Big(curr.price || 0));
    }, new Big(0));
    const minus = (new Big(sum) - new Big(price || 0)).toFixed(2);
    return minus;
  };

  findTypeName = value => {
    let typeName = '';
    this.props.expendType.forEach(item => {
      if (value === item.value) {
        typeName = item.key;
      }
    });
    return typeName;
  };

  handleSubmit = () => {
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const params = values;
        params.details = this.details;
        this.props.onOk(params);
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { dataInfo, visible, dataItem } = this.props;
    const { count, minus, avg } = this.state;
    const { price } = this.props.form.getFieldsValue();
    const apportion = dataItem.apportion || {};
    const formItemLayout = {
      labelCol: { span: 7 },
      wrapperCol: { span: 17 },
    };
    const details = apportion.details || [];
    return (
      <Modal
        width={900}
        title="设置分摊方案"
        visible={visible}
        onCancel={() => this.props.onCancel(false)}
        onOk={this.handleSubmit}
      >
        <Form className="modalApportion">
          <Row>
            <Col span={8}>
              <FormItem label="分摊金额" {...formItemLayout}>
                {getFieldDecorator('price', {
                  rules: [{ required: true, message: '请设置分摊金额!' }],
                })(<Input />)}
              </FormItem>
            </Col>
            <Col span={8}>
              <FormItem label="分摊类型" {...formItemLayout}>
                {type[apportion.type]}
              </FormItem>
            </Col>
            <Col span={8}>
              <FormItem label="预算科目" {...formItemLayout}>
                {this.findTypeName(dataItem.type)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={7}>
              <FormItem label="分摊人数" {...formItemLayout}>
                {count}
              </FormItem>
            </Col>
            <Col span={9} push={1}>
              <FormItem label="分摊人均金额" {...formItemLayout}>
                {avg}
              </FormItem>
            </Col>
            <Col span={8}>
              <FormItem label="分摊金额" {...formItemLayout}>
                {dataInfo.price}
                {new Big(minus || 0).eq(new Big(0)) ? null : (
                  <span style={{ color: 'red', marginLeft: '8px' }}>差额{minus}元</span>
                )}
              </FormItem>
            </Col>
          </Row>
          <Divider />
          <Row>
            <SelectApportionObj
              price={price || 0}
              onChange={this.handleChange}
              dataItem={dataItem}
              choosedArr={details}
            />
          </Row>
          <Divider />
          <Row>
            <Col span={24}>
              <FormItem label="分摊说明" labelCol={{ span: 2 }} wrapperCol={{ span: 22 }}>
                {getFieldDecorator(
                  'remark',
                  {},
                )(<Input.TextArea placeholder="备注" type="textarea" maxLength={1000} />)}
                <span style={{ fontSize: '12px', color: '#999' }}>*最多可输入1000字</span>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  }
}

export default Form.create()(ModalApportion);



// WEBPACK FOOTER //
// ./src/components/comm/apportion/ModalApportion2.js